export default function Specialization() {
  return (
    <section id="specialization" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 font-['Playfair_Display']">
            Специализация: Архитектура веб-сайта под ваш тип бизнеса
          </h2>
          <p className="text-base sm:text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] text-justify">
            Мы не просто наполняем страницы текстом — мы создаем логику продаж, исходя из того, как ваш клиент принимает решение.
          </p>
        </div>

        {/* Two Columns */}
        <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
          {/* Column 1: Experts */}
          <div className="bg-[#F8F9FA] rounded-3xl p-6 sm:p-10 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-user-star-line text-2xl sm:text-3xl text-white"></i>
            </div>
            
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Для Экспертов, Специалистов
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 italic font-['Montserrat']">
              Эксперт, Мастер-тренер, Специалист, Сервисный бизнес
            </p>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed font-['Montserrat'] text-justify">
              Когда ваш главный актив — это доверие и экспертность, сайт должен подтверждать вашу ценность еще до первого звонка.
            </p>

            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Стратегия «Продажа без давления»:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Мы выстраиваем контент по «Лестнице Ханта», чтобы перевести посетителя из состояния «просто смотрю» в состояние «хочу работать именно с вами».
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Инструменты доверия:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Интерактивные блоки с кейсами (результатами), видео-визитки и разделы «вопрос-ответ», снимающие возражения.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Автоматизация прогрева:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Внедряем квизы-опросники и лид-магниты, которые квалифицируют клиента и экономят ваше время.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Локальное SEO:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Настройка сайта так, чтобы клиенты находили вас первыми по локальным запросам.
                  </p>
                </div>
              </li>
            </ul>
          </div>

          {/* Column 2: Products */}
          <div className="bg-[#F8F9FA] rounded-3xl p-6 sm:p-10 border border-[#C5A880]/20 hover:shadow-xl transition-all duration-300">
            <div className="flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full mb-5 sm:mb-6">
              <i className="ri-shopping-bag-3-line text-2xl sm:text-3xl text-white"></i>
            </div>
            
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] mb-3 sm:mb-4 font-['Playfair_Display']">
              Для готовых товаров
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 italic font-['Montserrat']">
              Красота и Здоровье, Электроника, Детские товары, Спорт и Отдых и другие товары
            </p>
            <p className="text-sm sm:text-base text-gray-700 mb-4 sm:mb-6 leading-relaxed font-['Montserrat'] text-justify">
              Когда важна скорость выбора и легкость покупки.
            </p>

            <ul className="space-y-4 sm:space-y-5">
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Фокус на «Мгновенной конверсии»:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Проектируем интуитивный путь от карточки товара до кнопки «Оплатить».
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Мобильная вёрстка Mobile-First:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    80% ваших покупателей придут со смартфонов. Ваш сайт будет летать и идеально отображаться на любом экране.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">Социальное доказательство:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Умные блоки отзывов и интеграция с мессенджерами для быстрых консультаций.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-[#C5A880] rounded-full flex items-center justify-center mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <strong className="text-[#1A2B4C] font-['Montserrat'] text-sm sm:text-base">SEO-фундамент:</strong>
                  <p className="text-gray-700 mt-1 font-['Montserrat'] text-sm sm:text-base text-justify">
                    Правильная структура категорий и оптимизация карточек товаров для бесплатного трафика.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}